import { PlusCircleOutlined } from "@ant-design/icons";
import { Button } from "antd";
import { observer } from "mobx-react-lite";
import * as React from "react";
import { Link, useParams } from "react-router-dom";
import { onError } from "src/common/onError";
import { LoaderBox } from "src/components/LoaderBox";
import { MdmTable } from "src/components/MdmTable";
import { PageLayout } from "src/components/PageLayout";
import { PageSubheader } from "src/components/PageSubheader";
import { ToolBox2 } from "src/components/ToolBox2";
import { makeUrl } from "src/routes/makeUrl";
import { PageUrl } from "src/routes/PageUrl";

import {
  valueCatalogContentStore as pageStore,
  ValueCatalogData,
} from "./ValueCatalogContentStore";

export const ValueCatalogContent: React.FC = observer(() => {
  const { id = "" } = useParams();
  React.useEffect(() => {
    pageStore.init(id).catch(onError);
  }, [id]);
  return (
    <PageLayout title={pageStore.title}>
      <LoaderBox
        remoteData={pageStore.data}
        drawReady={(data) => <Inner data={data} />}
      />
    </PageLayout>
  );
});

const Inner: React.FC<{ data: ValueCatalogData }> = observer(({ data }) => {
  const { catalog, table, columns } = data;
  return (
    <>
      <PageSubheader title={catalog.name}>
        <Link to={makeUrl(PageUrl.valueCatalogNew, { id: catalog.id })}>
          <Button type="primary" icon={<PlusCircleOutlined />}>
            Запись
          </Button>
        </Link>
      </PageSubheader>

      <ToolBox2 paddingMode="page">
        <MdmTable
          store={table}
          columns={columns}
          resizableColumns
          rowClick={{
            type: "link",
            builder: (row) => makeUrl(PageUrl.valueCatalogEdit, { id: row.id }),
          }}
        />
      </ToolBox2>
    </>
  );
});
